var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.485 3.515A11.922 11.922 0 0 0 11.999 0a11.922 11.922 0 0 0-8.485 3.515A11.921 11.921 0 0 0 0 12c0 3.205 1.248 6.219 3.514 8.485A11.921 11.921 0 0 0 12 24a11.92 11.92 0 0 0 8.486-3.515A11.921 11.921 0 0 0 24 12c0-3.205-1.249-6.219-3.515-8.485zM11.999 22.06C6.452 22.061 1.94 17.548 1.94 12S6.451 1.939 11.998 1.939C17.546 1.939 22.06 6.452 22.06 12s-4.514 10.061-10.062 10.061z",
    fill: "#212B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.618a.97.97 0 0 0-.97.97v8.824a.97.97 0 1 0 1.94 0V7.588a.97.97 0 0 0-.97-.97z",
    fill: "#212B36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.412 11.03H7.588a.97.97 0 1 0 0 1.94h8.824a.97.97 0 1 0 0-1.94z",
    fill: "#212B36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.a985d4649240270976384b778eedb81c.svg";
export { ForwardRef as ReactComponent };